import React, { useEffect, useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
// import { useStoreState } from 'easy-peasy';
import { useLocation, useNavigate } from 'react-router';
import { useStoreState } from 'easy-peasy';

import Sign from '../containers/Sign/Sign';
import Register from './SignUp/Register';
import Spinner from './common/Spinner/Spinner';
import ProjectDetailsNew from '../containers/ProjectDetails/ProjectDetails';
import CreateProject from './CreateProject/CreateProject';
import UserProjects from '../containers/UserProjects/UserProjects';
import Home from '../containers/Home/Home';

const RouteOptions = {
  NOT_CONNECTED: 'NOT_CONNECTED',
  CREATOR: 'CREATOR',
  DASHBOARD: 'DASHBOARD',
};

const Router = (props) => {
  const [routerAction, setRouterAction] = useState(null);

  const { isWalletConnected, account } = useStoreState((state) => state.walletStore);

  const location = useLocation();
  const navigate = useNavigate();

  const defaultRoutes = (
    <>
      <Route path="/" element={<Home />} />
      {/* <Route path="/project/details" element={<ProjectDetails />} /> */}
      <Route path="/project/details/:id" element={<ProjectDetailsNew />} />
      {/* <Route path="/" element={<Dashboard />} /> */}
      <Route path="*" element={<Navigate to='/' />} />
    </>
  )

  useEffect(() => {
    setRouterAction(resolveNavigationRoute())
  });

  useEffect(() => {
    if ('#' + location.pathname !== window.location.hash) {
      navigate(location.pathname)
    }
  }, [location.pathname]);

  const resolveNavigationRoute = () => {
    switch (true) {
      case !isWalletConnected:
        return RouteOptions.NOT_CONNECTED;
      case isWalletConnected && !!account.token:
        return RouteOptions.CREATOR;
      case isWalletConnected && !account.token:
        return RouteOptions.NOT_CONNECTED;
      default:
        return RouteOptions.DASHBOARD;
    }
  };

  if (!routerAction) {
    return (<Spinner />)
  }

  if (routerAction) {
    switch (routerAction) {
      case RouteOptions.CREATOR:
        return <Routes>
          <Route path="/create" exact element={<CreateProject />} />
          <Route path="/my-projects" exact element={<UserProjects />} />
          {defaultRoutes}
        </Routes>
      case RouteOptions.NOT_CONNECTED:
        return <Routes>
          <Route path="/login" exact element={<Sign />} />
          <Route path="/register" exact element={<Register />} />
          {defaultRoutes}
        </Routes>
      default:
        return <Routes>
          {defaultRoutes}
        </Routes>
    }
  }
}

export default Router;
